var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn num-btn",attrs:{"id":"NUMBER_0","name":"0","data-vcode":"NUMBER_0","aria-label":`0 ${_vm.$t('spaceButton')}`}},[_c('div',{staticClass:"digit"},[_vm._v("0")]),_c('div',{staticClass:"letters"},[_vm._v(_vm._s(_vm.$t('spaceButton')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }